<template>
    <div>
        <h1 class="page-title">
            Terms &amp; Conditions
        </h1>
        <h2>General</h2>
        <p>
            These pages set out the terms and conditions which My Online Estate Agent Limited trading as My Online Estate
            Agent.com, referred to as “the company” hereon in, provides you with the services (defined below) and access
            to www.myonlineestateagent.com (“the website”).
        </p>
        <p>
            My Online Estate Agent Limited is registered in England &amp; Wales, company no. 09032238. VAT no.189 1048
            85.Registered office: Suite 3D MIOC, Styal Road, Manchester, M22 5WB.
        </p>
        <p>
            Please ensure that you read these terms and conditions carefully before using the services of the website.
            You agree to be bound to these terms and conditions by using the website and it services.
        </p>
        <p>
            Our terms and conditions are governed by and should be should be read in conjunction with the law of England
            and Wales. You and the company agree to the exclusive jurisdiction of the courts of England and Wales should
            any dispute between the parties arise.
        </p>
        <p>If you have any queries please contact Customer Services at; enquiries@myonlineestateagent.com</p>
        <h3>Sales Packages</h3>
        <p>
            The ‘Pay Now’ sales package incurs a non-refundable up-front fee which is payable at the time of choosing the
            product and instructing the company.
        </p>
        <p>
            The duration of marketing for all sales packages is six calendar months from the date you instruct the
            company to market your property or until a sale is agreed ‘subject to contract’ whichever occurs the
            soonest.
        </p>
        <p>
            The company will not market properties “for sale” on behalf of other estate agents or any entity or person
            who is not the owner of the property being presented for sale.
        </p>
        <h3>Existing Estate Agent Contractual Obligations</h3>
        <p>
            It is the responsibility of the vendor to make the company aware of any existing estate agents’ contractual
            obligations that they may be subject to. Vendors who are subject to existing ‘sole agency’ or ‘sole selling
            rights’ contracts are required to change the contract to a joint or multiple agency agreement or give notice
            according to the terms of the existing contract if they wish to market their property with the company.
        </p>
        <p>
            Vendors who do not disclose to the company any other existing contractual obligations may be required to also
            pay fees to another firm as well as those payable to the company.
        </p>
        <h3>UK Anti-Money Laundering Regulations (AML)</h3>
        <p>The company complies with the 2007 UK Money laundering Regulations.</p>
        <p>
            In accordance with UK Regulations we are required by law to confirm the identity of all property owners where
            a property is being advertised ‘for sale’ at the outset of commencing a business relationship with them. We
            are also required to keep a record of the evidence we have verified. If for any reason we are unable to
            confirm your identity during the course of establishing a business relationship with you, we reserve the
            right to withdraw the property for sale until an acceptable form of identity is received.
        </p>
        <p>
            The Company performs electronic identity checks using the name, address and date of birth information for
            each of the legal owners of the property. The Company can at its discretion levy a charge to cover its costs
            of performing these mandatory identity checks and these charges, where applicable, will be notified to you
            in the shopping cart area of the company’s website. The identity information will be collected by the
            Company at the earliest opportunity following the establishment of a business relationship with you.
        </p>
        <h3>Letting Packages</h3>
        <p>
            The ‘Tenant Find’ and ‘Essentials’ lettings packages incur a non-refundable up-front fee which is payable at
            the time of choosing the product and instructing the company.
        </p>
        <p>The package fees are chargeable per tenancy created on the following basis;</p>
        <ol type="a">
            <li>On a per property basis if the property is let as a whole, or</li>
            <li>
                On a per room basis if individual rooms are being let under separate tenancy agreements within the same
                building.
            </li>
        </ol>
        <p>
            The initial marketing fee for all letting packages which include the ‘Tenant Finder’ and ‘Essentials’,
            packages applies to a marketing period of <strong>six weeks</strong> from the date the payment is made to
            the company or when the property is let, whichever occurs the soonest. Where either the ‘Tenant Find’ or
            ‘Essentials packages are taken there is no completion fee and no additional fees are chargeable to the
            landlord after the initial fee has been paid save for the purchase of optional products as displayed in the
            shopping cart area of the website.
        </p>
        <h3>Right to Rent Legislation (changes) 1st February 2016</h3>
        <p>
            Under section 22 of the Immigration Act 2014 a landlord cannot authorise any adult to occupy a rental
            property as a tenant or lodger under a residential tenancy agreement unless the adult is a British citizen,
            or EEA or Swiss national, or has a “right to rent” in the UK. A person will have the “right to rent” in the
            UK provided they are present lawfully in accordance with immigration laws. In accordance with this
            legislation the landlord of this property is responsible for performing the appropriate immigration checks
            directly with the tenant(s) prior to the start of a new tenancy. Landlords who breach section 22 may be
            liable for a civil penalty.
        </p>
        <p>
            By instructing the Company the landlord confirms that he will perform the appropriate ‘Right to Rent’
            immigration checks prior to granting a tenancy.
        </p>
        <h3>Gas Safety Inspections</h3>
        <p>
            It is a legal requirement to have your rental property inspected and certificated on an annual basis for gas
            safety and compliance where a gas supply is connected to it. This remains the sole responsibility of the
            landlord and the Company takes no responsibility for ensuring your compliance with such legal and regulatory
            requirements. Where your property is subject to a gas safety inspection and certification the company
            requires that landlords produce a copy of a valid Gas Safety Certificate (GSC) prior to the commencement of
            marketing.
        </p>
        <h3>Energy Performance Certificates</h3>
        <p>
            Under UK law if you are selling a property it must have a valid energy performance certificate (EPC). The
            company will not market sales properties which do not have a valid EPC. If the EPC is not obtained you will
            be in breach of the Regulations and may be penalised. You may ask the company to commission an EPC on your
            behalf, the cost of which is displayed on our website.
        </p>
        <h3>Property Information</h3>
        <p>
            The company will share the property details to be marketed with the property owner who should advise the
            company of any inaccuracies at the earliest opportunity. Any material changes that the vendor wishes to make
            post instruction must be notified to the company for approval.
        </p>
        <h3>Consumer Protection from Unfair Trading Regulations 2008.</h3>
        <p>
            The Company must by law comply with the Consumer Protection from Unfair Trading Regulations 2008. These
            regulations require us to disclose any information of which we are aware or should be aware of in relation
            to the property in a clear, intelligible and timely fashion and to take all reasonable steps that all
            statements that we make about a property, whether oral, pictorial or written, are accurate and not
            misleading. All material information must be disclosed and there must be no material omissions which may
            impact on the average consumer’s transactional decision and where information is given to potential buyers
            or their representatives, it must be accurate and not misleading. You agree to take all reasonable steps to
            provide the company with all relevant information to enable us to comply fully with our obligations under
            the CPR in respect of the company’s agreement with you.
        </p>
        <p>
            You are liable for the duration of this agreement to reimburse us for all reasonable losses, costs, expenses,
            claims, commissions, settlements, fines, damages or other liabilities incurred by us which result from any
            wilful or negligent breach by you of your obligations in this agreement.
        </p>
        <h3>Accepting Offers</h3>
        <p>
            Sale properties &#8211; any offers received or accepted directly by the homeowner from a buyer must be
            communicated to the company in writing by post or by email.
        </p>
        <h3>Our Fees</h3>
        <p>
            You accept responsibility to pay our fees and any other charges agreed by yourself and us. You are hereby
            confirming to us that you are the sole or joint legal owner with another party and by agreeing to be bound
            by these terms and conditions, you are confirming to us that you are agreeing to these terms and conditions
            on behalf of all owners of the property.
        </p>
        <p>By accepting this agreement you are confirming that you have read and understood this agreement and that:</p>
        <p>-You are personally liable for our fees and all agreed cost and charges; and that</p>
        <p>
            -Where you have signed on behalf of someone else, you are jointly and severally liable with that person for
            our fees (and where applicable, any other costs or charges agreed and incurred by us on your behalf).
        </p>
        <h3>Notice of “Your Right to Cancel Your Order”</h3>
        <p>
            Where the terms of this Agreement are accepted online or at your home or place of work you have a right under
            “The Consumer Contract (Information, Cancellation and Additional Charges) Regulations 2013” to cancel this
            agreement within 14 days (known as the “14 day cooling off period”) starting the day after the day the
            contract was formed by accepting these terms via the company’s website at the time of purchasing our
            services.
        </p>
        <p>
            You may exercise this right to cancel if you wish by sending an email to sales@MyOnlineEstateAgent.com or by
            posting a letter to the postal address provided on our website.
        </p>
        <p>
            Where your contract is cancelled within the specified “14 day cooling off period&#8221; no charges will be
            due and you will be entitled to a full refund of any payments already made subject to the conditions set out
            in the “Performance of this Agreement” as below.
        </p>
        <p>For pre-paid services, any refunds will be made to you without undue delay, and no later than;</p>

        <ol type="I">
            <li>
                14 days after the day we receive back from you any goods supplied (where this is relevant e.g a for
                sale/to let board), or
            </li>
            <li>
                if there were no physical goods supplied, 14 days after the day on which we are informed about your
                decision to cancel your order.
            </li>
            <li>
                Any reimbursement will be made to you using the same means of payment as you used for the initial
                transaction.
            </li>
        </ol>
        <h3>Performance of this Agreement</h3>
        <p>
            If you have requested to begin the performance of pre-paid services during the “14 day cooling off period”,
            you will be required to pay an amount which is in proportion to what has been used until you have
            communicated to us by email or by letter your cancellation of this order, in comparison with the full cost
            of the product(s) ordered.
        </p>
        <p>
            Unless you inform us to the contrary, your purchase of pre-paid services from us will be taken as a request
            by you to immediately begin the performance of such services, within the “14 day cooling off” period,
            subject to the company’s final approval of the listing.
        </p>
        <p>
            Should you wish to use the “14 day cooling off period” you should do so before the commencement of marketing
            by sending an email to rentals@myonlineestateagent.com stating your intentions.
        </p>
        <p>
            Services performed include but are not limited to; portal advertising, home visits, photography, production
            of advertising text, floorplans, EPC’s and other services performed by the Company or its partner
            suppliers.
        </p>
        <h3>Overpayments</h3>
        <p>
            Where an overpayment occurs, a refund may be issued following a written request to the company by email.
            Where the initial payment was made by debit or credit card, a refund will only be applied to the same credit
            or debit card used for the initial transaction.
        </p>
        <h3>Using Your Information</h3>
        <p>
            As a landlord you explicitly agree that the company can share your contact details with potential tenants for
            the purpose of answering enquiries and arranging viewings. Your instruction is accepted on the basis that
            all viewings are conducted by the landlord or the landlord’s appointed representative.
        </p>
        <p>
            The company retains the right to remove any property advert from its advertising mediums should any of the
            above terms not be complied with.
        </p>
        <p>
            If you make an enquiry via our website about tenant vacancy relating to a property on our website, by doing
            so you acknowledge and agree that by doing so certain of your details (your name, email address and
            telephone number) will be shared automatically with the landlord.
        </p>
        <h3>Other Estate Agents and Financial Advisors</h3>
        <p>
            The Company will from time to time need to disclose the name, address, contact details, the proposed purchase
            address, the purchase price and any conditions of sale in relation to both the Seller and the Purchaser to
            any Estate Agent and/or Financial Advisor involved in the transaction. By agreeing to these Terms you agree
            to allow us to disclose this information.
        </p>
        <h3>Credit and Debit Card Payments</h3>
        <p>
            Credit and debit card payments are accepted for payment of the company’s property marketing services and
            additional ‘add on’ products as described on the company’s website.
        </p>
        <p>
            The company cannot accept any liability if your card payment is declined by the card supplier. The company
            has no control over acceptance of card payments and refusal of payment should be taken up with your card
            supplier directly.
        </p>

        <h3>Refused Payments</h3>

        <p>
            If your payment is refused, the online payment system will indicate this to you on the display screen. It is
            the card issuing bank that is refusing to authorise the payment and not the company. In the event that this
            occurs you will need to contact your card company directly to ascertain the reasons for the refusal.
        </p>

        <h3>Security</h3>

        <p>
            The company provides a secure online payments facility, fully managed to Level 1 approval in line with the
            Payment Card Industry (PCI) requirements. When you click on the link to make a payment you will be
            re-directed to a fully hosted secure managed environment. All information that you send will be fully 128
            bit encrypted.
        </p>
        <p>
            The online payment service is managed externally by a third party Financial Conduct Authority regulated
            company. The company does not hold any card details on any of its servers or within its infrastructure. The
            company does not have access to any of your card details on the managed service.
        </p>
        <p>
            The online payments system complies with all of the security requirements of the PCI council – CV2 input,
            Verified by Visa, MasterCard Security code etc. The company will continue to enhance the application to the
            highest security standards.
        </p>

        <h3>Additional Services</h3>

        <p>
            The company may offer additional services via our partners to our sales and lettings customers which include
            mortgages, insurance products, conveyancing, tenant referencing, removal and other services and
            products.
        </p>

        <h3>Privacy</h3>

        <p>
            The company is fully committed to protecting your privacy online. Personal data which is requested as part of
            the payment process, will be treated in accordance with the Data Protection Act 1998.
        </p>
        <p>
            We will only use any personal that you have provided, for the purposed of which you provide it or for other
            lawful purposes. If you are purchasing a landlord package you will agree that the company can share your
            name and contact details with any potential tenants. Your personal data will be held for as long as
            necessary for these purposes and will not be passed to any third parties unless we are required to do so by
            law. Employees with access to your personal data or are involved in the handling of data are obligated to
            respect the confidentiality of your personal data.
        </p>

        <h3>Limitation of Liability</h3>

        <p>
            The company cannot guarantee the accuracy of information on the website and reserves the right to change the
            website content (including these terms and conditions) at any time.
        </p>
        <p>
            The company makes no representations or warranties with respect with respect to the website or the
            information it contains, that the functionality of the website will be uninterrupted or error free, that
            defects will be corrected or that the website or the server that makes it available are free of viruses or
            anything else which may be harmful or destructive.
        </p>
        <p>
            To the extent permitted by law, the company will not be liable for any indirect or consequential loss or
            damage (including without limitation loss of business, opportunity, data, profits) arising from or in
            association with the use of the website.
        </p>

        <h3>Indemnity</h3>

        <p>
            You agree to indemnify and hold the company, its employees and agents faultless for all liabilities, legal
            fees, damages, losses, costs and other expenses in relation to any legal claims or actions brought against
            the company arising from any breach by you of these terms and conditions or any other liabilities arising
            from your use of the website.
        </p>
        <h3>Breach and Fair Use Policy</h3>
        <p>
            In order to protect users of our services and the Company’s website we reserve the right to remove or edit
            without notice any listings we deem to be in breach of these terms, and in that event we may deduct the cost
            of any goods or services provided, along with any of our costs and expenses arising from your breach, from
            any full or partial refund which might otherwise be due to you in respect of any goods or services for which
            you have already paid at the date of removal.
        </p>
        <p>
            Although we don’t expect our fair usage limits to be breached by genuine landlords or sellers, we reserve the
            right to remove any listings at our absolute sole discretion or make such additional charges as we deem
            appropriate.
        </p>

        <h3>Miscellaneous</h3>

        <p>
            You may not assign, sub-license or otherwise transfer any of your rights under these Terms and
            Conditions.
        </p>
        <p>
            If any provision of these Terms and Conditions is found to be invalid by any court having competent
            jurisdiction, the invalidity of that provision will not affect the validity of the remaining provisions of
            these Terms and Conditions, which shall remain in full force and effect.
        </p>
        <p>
            If you breach these Terms and Conditions and My Online Estate Agent Limited ignores this, My Online Estate
            Agent Limited will still be entitled to use its rights and remedies at a later date or in any other
            situation where you breach the Terms and Conditions.
        </p>
        <p>
            My Online Estate Agent Limited shall not be responsible for any breach of these Terms and Conditions caused
            by circumstances beyond its control.
        </p>
        <p>
            A person who is not a party to these Terms and Conditions shall have no right under the Contract (Rights of
            Third Parties) Act 1999 to enforce any term of these Terms and Conditions but this shall not affect any
            right or remedy of a third party which exists or is available apart from that Act.
        </p>
        <p><sub>Last update: 26/09/2016 © MyOnlineEstateAgent Limited, 2016</sub></p>
    </div>
</template>

<script>

export default {
    name: 'TermsConditions'
};
</script>

<style lang="scss">

</style>
